<template>
  <div>
    <div class="md-layout-item md-size-25 md-small-size-100">
      <validation-field :validations="validations.recipients" name="recipient">
        <label>{{ $t("communication.choose_recipient") }}</label>
        <md-select
          name="recipient"
          v-model="data.recipients"
          id="recipient"
          required
        >
          <md-option value="Student">{{ $t("common.student") }}</md-option>
          <md-option value="Teacher">{{ $t("common.teacher") }}</md-option>
        </md-select>
        <span
          style="top:40px"
          class="md-error"
          v-if="serverValidations.recipients"
          >{{ serverValidations.recipients }}</span
        >
      </validation-field>
    </div>
    <div v-if="data.recipients === 'Student'">
      <students :hasCheckBox="hasCheckBox" :data="data"></students>
    </div>
    <div v-if="data.recipients === 'Teacher'">
      <teacher :data="data"></teacher>
    </div>
  </div>
</template>
<script>
import Students from "./Students";
import Teacher from "./Teacher";

export default {
  name: "FilterOptions",
  props: ["data", "validations", "serverValidations", "hasCheckBox"],
  components: { Students, Teacher },
  data() {
    return {
      target: "Student"
    };
  },
  watch: {
    "data.recipients": function() {
      this.data.filter_by = null;
    }
  }
};
</script>
